module.exports = __webpack_public_path__ + "static/fonts/FiraSans-Regular.808fbb6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FiraSans/FiraSans-Regular.ttf
// module id = 1158
// module chunks = 5